import React from "react";
import { getPortalAssetUrl } from "../api/client";
import type { TenantInfo } from "../api/types";

export function TenantLogo({
  tenant,
  compact = false,
}: {
  tenant: TenantInfo;
  compact?: boolean;
}) {
  const logoUrl = getPortalAssetUrl(tenant.portalLogoUrl);
  const [failed, setFailed] = React.useState(false);

  React.useEffect(() => {
    setFailed(false);
  }, [logoUrl]);

  if (logoUrl && !failed) {
    return (
      <img
        src={logoUrl}
        alt={`Logo ${tenant.nmtenant}`}
        className={
          compact
            ? "h-9 max-w-32 shrink-0 object-contain"
            : "mx-auto mb-4 max-h-16 max-w-48 object-contain"
        }
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      className={
        compact
          ? "flex size-9 shrink-0 items-center justify-center rounded-lg bg-teal-700 font-bold text-white"
          : "mx-auto mb-4 flex size-12 items-center justify-center rounded-xl bg-teal-700 text-lg font-bold text-white"
      }
      aria-label={`Identidade ${tenant.nmtenant}`}
    >
      {tenant.nmtenant.trim().charAt(0).toUpperCase() || "O"}
    </div>
  );
}
